<tps-assistant-form-shell [submissionState]="submissionState()" [errorMessage]="errorMessage()">
  <div assistantFormHeader>{{ i18n.translate('manufacturing-order:createNewOrder')() }}</div>

  <div assistantFormFields>
    <ngt-input-field [mode]="blocked() ? 'disabled' : 'active'" [label]="i18n.translate('manufacturing-order:orderName')()" [value]="orderName()" (valueChange)="setOrderName($event)" width="max" />
  </div>

  <div assistantFormActions>
    @if (submissionState() === 'idle') {
      <ngt-button (click)="createOrder()">{{ i18n.translate('manufacturing-order:createNewOrder')() }}</ngt-button>
    }
  </div>
</tps-assistant-form-shell>
